import React from 'react'
import ThemeCard from 'cms/CmsCard'

const Card = ({
  content: {
    source = '',
    link,
    target,
    header,
    description,
  },
  style,
  settings,
  goto,
  assets: {
    defaultImage,
  },
  renderElement,
  currentLang,
}) => (
  renderElement(
    ThemeCard,
    {
      style,
      ...settings,
      src: source,
      defaultImage,
      header,
      description,
      lang: currentLang,
      link: !!link,
      onClick: () => goto({ href: link, target }),
    }
  )
)

Card.propTypes = {}
Card.defaultProps = {}

export default Card



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/card/Card.js